class SegmentContentDataInputDefinition {
  static name = 'SegmentContentDataInputDefinition';

  constructor(componentName, segmentContentDataType) {
    this.componentName = componentName;
    this.segmentContentDataType = segmentContentDataType;
  }
}

export default SegmentContentDataInputDefinition;
